// extracted by mini-css-extract-plugin
export default {"container":"Cash_container__wT4Cu","euroIcon":"Cash_euroIcon__ImOlt","cash":"Cash_cash__teOST"};